/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inscription-note{font-size:12px!important}  .inscription-note p{margin-bottom:4px!important}"];
export { styles as styles };
